module.exports = __webpack_public_path__ + "cover-letter-47f61a13/template-4-2x-50b4ae1e9a1812538942af577a9ad05b.jpg";